
window.onload = function(){
    var gdprCookie = getCookie('GDPRCookiePrompt');
    if (!gdprCookie) {
        showGdprPopup();
    }
};


function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name+'=; Max-Age=-99999999;';
}
function showGdprPopup() {

    var css = ".gdpr-banner,.gdpr-banner__copy,.gdpr-banner__links .gdpr-banner__a{box-sizing:border-box}.gdpr-banner{background:#0b0b0b;width:100%;display:flex;flex-wrap:wrap;justify-content:space-between;padding:30px;align-items:center;position:fixed;bottom:0;left:0;z-index:999999999;}.gdpr-banner__a,.gdpr-banner__p{color:#fff;padding:0;margin:0;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:12px;font-weight:300;letter-spacing:1.2px}.gdpr-banner__a{text-decoration:underline; background: none; font-family:'Helvetica Neue',Helvetica,Arial,sans-serif; transition:.25s ease all;color:#fff}.gdpr-banner__a:active,.gdpr-banner__a:focus,.gdpr-banner__a:hover{outline:0;color:#b3b3b3;cursor:pointer}.gdpr-banner__copy{width:75%;padding-right:50px}.gdpr-banner__links{width:25%;text-align:right}.gdpr-banner__a.gdpr-banner__exit{text-decoration:none;color:#fff;position:relative;border:1px solid #fff;padding:5px 8px 5px 23px;display:inline-block;margin-left:15px}.gdpr-banner__a.gdpr-banner__exit::after,.gdpr-banner__a.gdpr-banner__exit::before{display:block;content:'';width:10px;height:2px;position:absolute;top:50%;left:8px;background:#fff;transition:.25s ease all}.gdpr-banner__a.gdpr-banner__exit::after{transform:translateY(-50%) rotate(45deg)}.gdpr-banner__a.gdpr-banner__exit::before{transform:translateY(-50%) rotate(-45deg)}.gdpr-banner__a.gdpr-banner__exit:active,.gdpr-banner__a.gdpr-banner__exit:focus,.gdpr-banner__a.gdpr-banner__exit:hover{color:#b3b3b3;border-color:#b3b3b3}.gdpr-banner__a.gdpr-banner__exit:active::after,.gdpr-banner__a.gdpr-banner__exit:active::before,.gdpr-banner__a.gdpr-banner__exit:focus::after,.gdpr-banner__a.gdpr-banner__exit:focus::before,.gdpr-banner__a.gdpr-banner__exit:hover::after,.gdpr-banner__a.gdpr-banner__exit:hover::before{background:#b3b3b3}@media (max-width:765px){.gdpr-banner__copy{box-sizing:border-box;padding-right:0}.gdpr-banner__a.gdpr-banner__exit{margin-top:10px}}@media (max-width:565px){.gdpr-banner__copy{padding-right:0}.gdpr-banner__links{text-align:left;padding-top:10px}.gdpr-banner__copy,.gdpr-banner__links{width:100%}}@media (max-width:220px){.gdpr-banner__a.gdpr-banner__exit{margin-left:0}}",
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet){
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
    var el = document.createElement('div');
    var domString = '<div id="gdpr-prompt" class="gdpr-banner"><div class="gdpr-banner__copy"><p class="gdpr-banner__p">Cookies help us deliver our services. By using our services, you agree to our use of cookies.</p></div><div class="gdpr-banner__links"><a href="/privacy" class="gdpr-banner__a" target="_blank">Learn More</a><button class="gdpr-banner__a gdpr-banner__exit" onclick="acceptCookiePrompt()">Close</button></div></div>';
    el.innerHTML = domString;
    document.body.appendChild(el.firstChild);
}

function acceptCookiePrompt(){
    setCookie('GDPRCookiePrompt','accepted',180);
    document.getElementById("gdpr-prompt").style.display = "none";
}


